import { api } from "@/api/client";

/** Thin wrapper around the shared axios `api` instance (cookies + 401-refresh already work
 * generically for ANY role, including "production_partner" — see api/client.js) — just
 * namespaces the PP1 Home Shell endpoints in one place, mirroring clientPortalApi.js. */
export const partnerWorkspaceApi = {
  requestLink: (email) => api.post("/v1/partner-portal/auth/request-link", { email }),
  verify: (token) => api.post("/v1/partner-portal/auth/verify", { token }),
  home: () => api.get("/v1/partner-portal/home"),
  uploadLogo: (file) => {
    const form = new FormData();
    form.append("file", file);
    return api.post("/v1/partner-portal/profile/logo", form, { headers: { "Content-Type": "multipart/form-data" } });
  },
  logoUrl: (partnerId) => `${api.defaults.baseURL}/v1/partner-portal/logo/${partnerId}`,
  // PP2a (2026-02): the per-partner Rate Card.
  rateCard: () => api.get("/v1/partner-portal/rate-card"),
  proposeChange: (canonicalId, body) => api.post(`/v1/partner-portal/rate-card/items/${canonicalId}/propose-change`, body),
  proposeNew: (body) => api.post("/v1/partner-portal/rate-card/items/propose-new", body),
  bulkImport: (rows) => api.post("/v1/partner-portal/rate-card/bulk-import", { rows }),
  downloadTemplateBlob: () => api.get("/v1/partner-portal/rate-card/template", { responseType: "blob" }),
  // PP2c (2026-02): onboarding — filling in / submitting a blank Draft card.
  setDraftItem: (canonicalId, body) => api.post(`/v1/partner-portal/rate-card/draft-items/${canonicalId}`, body),
  submitCard: () => api.post("/v1/partner-portal/rate-card/submit"),
};
